<template>
  <va-card :title="$t('menu.loads')">
    <div class="row">
      <div class="flex xs12 sm2">
        <va-date-picker
          :label="$t('tables.date')"
          v-model="delivery_date"
        />
      </div>

      <div class="flex" style="margin-left: -20px">
        <va-button
          small
          color="secondary"
          icon="fa fa-eraser"
          class="ma-2"
          @click="clear(delivery_date)"
        >
          {{ $t('menu.clear') }}
        </va-button>
      </div>

      <div class="flex xs3">
        <va-select
          v-model="loadType"
          :options='loadTypes'
          label="Tipo de Carga"
          textBy="name"
          keyBy="id"
          clearable="false"
          placeholder="Selecione o tipo de carga"
        />
      </div>

      <div class="flex xs12 md3">
        <va-input
          v-model="search"
          :label="$t('menu.search')"
          removable
        >
        </va-input>
      </div>

      <div class="flex md1">
        <va-button
          small
          color="secondary"
          icon="fa fa-search"
          class="ma-2"
          @click="readItems(page, search)"
        >
          {{ $t('menu.search') }}
        </va-button>
      </div>

      <div class="flex xs12 md2 offset--md0">
        <va-select
          v-model="perPage"
          :value="perPage"
          :label="$t('tables.perPage')"
          :options="perPageOptions"
        />
      </div>
    </div>

    <div class="row" v-if="ability.can('import', 'Loads')">
      <div class="flex xs12 sm3">
        <va-select
          v-model="selected_import"
          :options='import_kinds'
          label="Tipo de Importação"
          textBy="name"
          keyBy="path"
          clearable="false"
          placeholder="Selecione o tipo de importação"
        />
      </div>

    <div class="flex xs12 sm3">
      <va-button v-if="ability.can('import', 'Loads')"
          medium
          inline
          color="secondary"
          icon="fa fa-cloud-upload"
          class="ml-2"
          @click.native="goToImport()"
        >
          {{ $t('menu.import') }}
        </va-button>

        <va-button v-if="this.delivery_date != '' && this.data.length > 0"
          medium
          inline
          color="green"
          icon="fa fa-download"
          class="ml-2"
          @click.native="exportLoadsReport()"
        >
          {{ $t('menu.export') }}
        </va-button>
      </div>
    </div>
    <div class="row">
      <div class="flex xs12 sm7">

        <va-button v-if="ability.can('create', 'Loads')"
          medium
          inline
          color="secondary"
          icon="fa fa-plus"
          class="ma-0"
          to="/admin/forms/form-loads"
        >
          {{ $t('menu.new') }}
        </va-button>
      </div>
    </div>

    <div v-show="loading" class="text--center pb-4">
      <div class="flex-center spinner-box">
        <slot name="loading">
          <spring-spinner
            slot="loading"
            :animation-duration="currentDuration"
            :is="spload.name"
            :color="spinnersColor"
            :size="config.size"
          />
        </slot>
      </div>
    </div>

    <va-data-table
      v-if="renderComponent"
      :fields="fields"
      :data="data"
      :per-page="parseInt(perPage)"
      :total-pages="parseInt(totalPages)"
      v-show="!loading"
      no-pagination
      api-mode
      @page-selected="readItems"
    >

    <template slot="actions" slot-scope="props">
      <va-button v-if="props.rowData.divergence_load_products.length > 0"
          small
          inline
          color="danger"
          icon="fa fa-list-alt"
          class="ma-1"
          :to="{ name: 'data-table-load-divergences', params: { loadID: props.rowData.id, loadCode: props.rowData.code, assemblyLine: 9, delivery_date: delivery_date, current_page: current_page, search: search, perPage: perPage } }"
        >
          {{ $t('menu.divergence') }}
        </va-button>
      <va-button v-if="props.rowData.load_histories_count > 0"
          small
          inline
          color="green"
          icon="fa fa-list-alt"
          class="ma-1"
          :to="{ name: 'load-history', params: { loadId: props.rowData.id, loadCode: props.rowData.code, assemblyLine: 9, delivery_date: delivery_date, current_page: current_page, search: search, perPage: perPage } }"
        >
          {{ $t('menu.order_history') }}
      </va-button>
      <va-button
        small
        inline
        color="dark"
        icon="fa fa-list-alt"
        class="ma-0"
        :to="{ name: 'lists-load-table', params: { loadID: props.rowData.id, loadCode: props.rowData.code, assemblyLine: 9 ,delivery_date: delivery_date, current_page: current_page, search: search, perPage: perPage } }"
      >
        {{ $t('menu.lists') }}
      </va-button>
      <va-button v-if="props.rowData.loads_checked == true "
        small
        inline
        color="#118ab2"
        icon="fa fa-list-alt"
        class="ma-1"
        :to="{ name: 'load_checks', params: { loadId: props.rowData.id, loadCode: props.rowData.code, delivery_date: delivery_date, current_page: current_page, search: search, perPage: perPage } }"
      >
        {{ 'Checkout' }}
      </va-button>
      <va-button
        small
        inline
        color="greenLight"
        icon="fa fa-list-alt"
        class="ma-1"
        :to="{ name: 'agrouped_load_products_by_load', params: { loadID: props.rowData.id, loadCode: props.rowData.code, assemblyLine: 9, delivery_date: delivery_date, current_page: current_page, search: search, perPage: perPage } }"
      >
        {{ $t('menu.products') }}
      </va-button>

      <va-button
        small
        inline
        color="#ff842b"
        icon="fa fa-table"
        class="ma-1"
        v-if="props.rowData.status_id > 13"
        :to="{ name: 'palletized_products_by_load', params: { loadID: props.rowData.id, loadCode: props.rowData.code, delivery_date: delivery_date, assemblyLine: 9, current_page: current_page, search: search, perPage: perPage } }"
      >
        {{ $t('menu.palletized_products') }}
      </va-button>

      <va-button
        small
        inline
        color="#007db8"
        icon="fa fa-check-square"
        class="ma-1"
        v-if="props.rowData.status_id > 13"
        :to="{ name: 'billed_products_by_load', params: { loadID: props.rowData.id, loadCode: props.rowData.code, delivery_date: delivery_date, assemblyLine: 9, current_page: current_page, search: search, perPage: perPage } }"
      >
        {{ $t('menu.billed_products') }}
      </va-button>

      <va-button
        small
        inline
        color="dark"
        icon="fa fa-list"
        class="ma-1"
        v-if="props.rowData.status_id > 13"
        :to="{ name: 'data-table-load-products', params: { loadID: props.rowData.id, loadCode: props.rowData.code, delivery_date: delivery_date, assemblyLine: 9, current_page: current_page, search: search, perPage: perPage } }"
      >
        {{ $t('menu.load_products') }}
      </va-button>

      <va-button v-if="ability.can('update', 'Loads')"
        small
        inline
        color="green"
        icon="fa fa-edit"
        class="ma-1"
        :to="{ name: 'form-loads', params: { id: props.rowData.id, loadCode: props.rowData.code, delivery_date: delivery_date, current_page: current_page, search: search, perPage: perPage } }"
      >
        {{ $t('menu.edit') }}
      </va-button>
      <va-button v-if="ability.can('destroy', 'Loads')"
        small
        inline
        color="danger"
        icon="fa fa-remove"
        class="ma-0"
        @click="showModalRemove = true, codeLoad = props.rowData.id"
      >
        {{ $t('tables.delete') }}
      </va-button>

    </template>
    </va-data-table>

      <Pagination
        :currentPage="current_page"
        :totalPages="totalPages"
        :onChange="onPageChange"
        v-show="!loading"
      />

      <va-modal
        v-model="showModalRemove"
        size="small"
        :title="$t('modal.remove')"
        :message="$t('modal.messageRemoveLoad')"
        hideDefaultActions
        :color="this.$themes.secondary"
      >

      <va-button
        color="danger"
        class="ma-2"
        @click="showModalRemove = false">
        {{$t('modal.cancel')}}
      </va-button>

      <va-button
        color="green"
        class="ma-2"
        @click="remove(codeLoad), showModalRemove = false">
        {{$t('modal.confirm')}}
      </va-button>
    </va-modal>
  </va-card>
</template>

<script>

import { mapState } from 'vuex'
import { Ability } from '@casl/ability'
import router from '../../../router/index.js'
import LoadAPI from '@/services/LoadAPI'
import * as spinners from 'epic-spinners'
import { showError } from '@/global'
import LoadTypeAPI from '@/services/LoadTypeAPI'
import Pagination from '../../shared/Pagination'

export const ability = new Ability()
export default {
  name: 'modals',
  components: {
    ...spinners,
    Pagination,
  },
  data () {
    return {
      data: [],
      loading: false,
      selected_import: '',
      config: {
        size: 80,
        group: 4,
        duration: 1500,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      showModal: false,
      ability: [],
      showModalRemove: false,
      codeLoad: '',
      perPage: '10',
      totalPages: 0,
      perPageOptions: ['10','20','30','40','50'],
      search: '',
      renderComponent: true,
      delivery_date: '',
      current_page: '',
      last_refresh: new Date(),
      loadTypes: [],
      loadType: {
        id: '',
        name: ''
      },
    }
  },

  channels: {
    NeedRefreshLoads: {
      received (data) {
        const last_received_refresh = ( new Date() - this.last_refresh) / 1000

        if (last_received_refresh >= 30) {
          this.last_refresh = new Date()
          this.readItems()
        }
      },
    },
  },

  beforeMount () {
    this.ability = ability.update(this.rules)
    if (this.$route.params.delivery_date !== undefined) {
      this.delivery_date = `${this.$route.params.delivery_date}`
    } else {
      this.readDeliveryDate(this.currentLocality.id)
    }
  },

  mounted () {
    this.$cable.subscribe({ channel: 'NeedRefreshLoads', company: this.currentUser.company })
    this.search = (this.$route.params.search !== undefined) ? `${this.$route.params.search}` : ''
    this.getDefaultLoadType()
  },

  computed: {
    ...mapState(['rules', 'currentLocality', 'currentUser']),

    import_kinds () {
      let imports = []

      if (ability.can('import', 'Loads')) {
        imports.push( { name: this.$t('menu.import_mounting'), path: '/admin/import-loads' })
        imports.push( { name: this.$t('menu.import_orders'), path: '/admin/import-orders' })
      }

      if (ability.can('import_solar_txt', 'Loads')) {
        imports.push( { name: this.$t('menu.import_solar_txt'), path: '/admin/import-solar-txt' })
      }

      if (ability.can('import_control', 'Loads')) {
        imports.push( { name: this.$t('menu.import_control'), path: '/admin/import-control' })
      }

      if (ability.can('import_control', 'Loads')) {
        imports.push( { name: this.$t('menu.import_heineken'), path: '/admin/import-heineken' })
      }

      return imports
    },

    fields () {
      return [{
        name: 'id',
        title: this.$t('tables.loads.id'),
      },
      {
        name: 'locality',
        title: this.$t('tables.loads.locality_name'),
      },
      {
        name: 'trip_number',
        title: this.$t('tables.loads.trip_number'),
      },
      {
        name: 'code',
        title: this.$t('tables.loads.code'),
      },
      {
        name: 'vehicle',
        title: this.$t('tables.loads.vehicle'),
      },
      {
        name: 'weight',
        title: this.$t('tables.loads.weight'),
      },
      {
        name: 'quantity_orders',
        title: this.$t('tables.loads.quantity_orders'),
      },
      {
        name: 'quantity_box',
        title: this.$t('tables.loads.quantity_boxes'),
      },
      {
        name: 'status',
        title: this.$t('tables.loads.status'),
      },
      {
        name: 'delivery_date',
        title: this.$t('tables.loads.delivery_date'),
      },
      {
        name: 'assembled_percentage',
        title: this.$t('tables.loads.assembled_percentage'),
      },
      {
        name: 'checked_percentage',
        title: this.$t('tables.loads.checked_percentage'),
      },
      {
        name: 'loaded_percentage',
        title: this.$t('tables.loads.loaded_percentage'),
      },
      {
        name: '__slot:actions',
        dataClass: 'text-right',
      }]
    },
    spload () {
      return spinners.ScalingSquaresSpinner
    }
  },
  watch: {
    perPage: function (newVal) {
      this.perPage = newVal
      this.readItems(this.current_page)
    },
    search: function (newVal) {
      if (!newVal) {
        this.readItems(this.current_page)
      }
    },
    delivery_date: function (newVal) {
      this.readItems(this.current_page)
    },

    loadType: function (newVal) {
      this.readItems()
    },

    '$store.state.currentLocality': function () {
      this.readItems(this.current_page)
    },

  },
  methods: {
    onPageChange (page) {
      this.readItems(page)
    },
    clear (field) {
      this.delivery_date = ''
    },
    goToImport () {
      router.push({ path: this.selected_import.path })
    },

    forceRerender () {
      this.renderComponent = false

      this.$nextTick(() => {
        this.renderComponent = true
      })
    },

    async readItems (page) {
      this.loading = true

      await LoadTypeAPI.getAllLoadTypes().then(response => {
        this.loadTypes = response.data.load_types
      }).catch(e => {
        showError(e)
      })

      const params = {
        locality: this.currentLocality.id,
        page: page,
        quantity: this.perPage,
        search: this.search,
        delivery_date: this.delivery_date,
        load_type_id: this.loadType.id,
      }
      this.current_page = this.$route.params.current_page

      await LoadAPI.getFilteredLoads(params)
        .then(response => {
          this.totalPages = response.data.total_pages
          this.current_page = response.data.current_page
          // this.delivery_date = (this.$route.params.delivery_date !== undefined) ? `${this.$route.params.delivery_date}` : response.data.last_delivery_date
          this.data = response.data.loads
          this.loading = false
        }).catch(e => {
          this.loading = false
          showError(e)
        })
    },
    async readDeliveryDate (localityId) {
      await LoadAPI.getLastDeliveryDate(localityId).then(response => {
        this.delivery_date = response.data.last_delivery_date
      }).catch(e => {
        showError(e)
      })
    },

    async getDefaultLoadType () {
      await LoadTypeAPI.getDefaultLoadType().then(response => {
        this.loadType = response.data.load_type
      }).catch(e => {
        showError(e)
      })
    },

    async remove (loadID) {
      this.loading = true
      await LoadAPI.deleteLoad(loadID)
        .then(response => {
          this.loading = false
          const rowItem = this.data.map((e) => e.id).indexOf(loadID)
          this.data.splice(rowItem, 1)

          this.showToast(response.data.message, {
            icon: 'fa-thumbs-o-up',
            position: 'top-right',
            duration: 5000,
          })

        this.forceRerender()
        this.readItems()
      }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    },

    exportLoadsReport () {
      let params = {
        locality: this.currentLocality.id,
        delivery_date: this.delivery_date,
        load_type_id: this.loadType.id,
      }

      LoadAPI.exportLoadsReport(params).then(response => {
        let url = process.env.VUE_APP_API_BASE_URL.replace('api/v1', '')
        let link = document.createElement('a')
        this.filepath = url + response.data.filename
        document.body.appendChild(link)
        link.href = this.filepath

        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })
        link.click()
      }).catch(e => {
        this.showToast(e.response.data.error, {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      })
    },
  },
}
</script>
